import React from "react";
import styled from "styled-components";
import { FiGithub, FiLinkedin, FiTwitter, FiInstagram, FiFacebook, FiArrowUp } from "react-icons/fi";
import { Bio } from "../../data/constants";

const FooterWrap = styled.footer`
  width: 100%;
  padding: 48px 24px 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const Top = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const LogoMark = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.gradient};
  font-family: "Space Grotesk", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #050507;
`;

const LogoText = styled.span`
  font-family: "Space Grotesk", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.text_primary};
`;

const Tagline = styled.p`
  font-size: 13.5px;
  color: ${({ theme }) => theme.text_muted};
  max-width: 320px;
`;

const Nav = styled.nav`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.text_secondary};
  text-decoration: none;
  font-size: 13.5px;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.text_primary};
  }
`;

const Socials = styled.div`
  display: flex;
  gap: 10px;
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: ${({ theme }) => theme.text_secondary};
  border: 1px solid rgba(255, 255, 255, 0.09);
  transition: all 0.25s ease;

  &:hover {
    color: ${({ theme }) => theme.text_primary};
    border-color: ${({ theme }) => theme.primary};
    transform: translateY(-2px);
  }
`;

const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
`;

const Copyright = styled.p`
  font-size: 12.5px;
  color: ${({ theme }) => theme.text_muted};
`;

const ToTop = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 12.5px;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.text_primary};
  }
`;

const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Projects" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" },
];

function Footer() {
  return (
    <FooterWrap>
      <Inner>
        <Top>
          <Brand>
            <LogoRow>
              <LogoMark>A</LogoMark>
              <LogoText>Jayson.</LogoText>
            </LogoRow>
            <Tagline>Lead Software Engineer &amp; IT Infrastructure Specialist, {Bio.location}.</Tagline>
          </Brand>

          <Nav>
            {NAV_LINKS.map((link) => (
              <NavLink key={link.id} href={`#${link.id}`}>
                {link.label}
              </NavLink>
            ))}
          </Nav>

          <Socials>
            <SocialIcon href={Bio.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FiGithub size={16} />
            </SocialIcon>
            <SocialIcon href={Bio.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FiLinkedin size={16} />
            </SocialIcon>
            <SocialIcon href={Bio.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FiTwitter size={16} />
            </SocialIcon>
            <SocialIcon href={Bio.insta} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FiInstagram size={16} />
            </SocialIcon>
            <SocialIcon href={Bio.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FiFacebook size={16} />
            </SocialIcon>
          </Socials>
        </Top>

        <Bottom>
          <Copyright>&copy; {new Date().getFullYear()} {Bio.name}. All rights reserved.</Copyright>
          <ToTop onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Back to top <FiArrowUp size={13} />
          </ToTop>
        </Bottom>
      </Inner>
    </FooterWrap>
  );
}

export default Footer;
